import React from "react";
import { Button } from "@chakra-ui/react";
import OperatorsTable from "./OperatorsTable";
import UsersFilter from "../UsersFilter";
import ContentCard from "../../Common/Layout/ContentCard";
import { useHistory } from "react-router-dom";
import Body from "../../Common/Body";

const Operators = () => {
  const history = useHistory();
  return (
    <Body title={"Lista de operadores"}>
      <ContentCard>
        <UsersFilter role={2}></UsersFilter>
      </ContentCard>
      <ContentCard>
        <Button
          my="2"
          colorScheme="blue"
          onClick={() => history.push("/usuarios/nuevo?roleId=2")}
        >
          + Operador
        </Button>
        <OperatorsTable></OperatorsTable>
      </ContentCard>
    </Body>
  );
};

export default Operators;
